import { render, staticRenderFns } from "./EmployeePropertyWorkAreaScheduleEdit.vue?vue&type=template&id=25b5fbf6&"
import script from "./EmployeePropertyWorkAreaScheduleEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeePropertyWorkAreaScheduleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip,QDialog,QCard,QCardSection,QItem,QSelect,QCheckbox,QInput,QInnerLoading,QSpinnerGears,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QDialog,QCard,QCardSection,QItem,QSelect,QCheckbox,QInput,QInnerLoading,QSpinnerGears,QSeparator,QCardActions}, component.options.components || {})
